import { useEffect } from 'react';

export const useOnClickOutside = (ref: HTMLElement | null, handler: (event: MouseEvent | TouchEvent) => void): void => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (event.target instanceof Node)
        if (!ref || ref?.contains?.(event.target)) {
          return;
        }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
